import z from 'zod';

export const AIPerformanceScorePointSchema = z.object({
  id: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  score: z.number(),
  createdAt: z.string().optional(),
  isVisible: z.boolean().optional(),
});

export type TAIPerformanceScorePoint = z.infer<
  typeof AIPerformanceScorePointSchema
>;

export const AIPerformanceScoresSchema = z.object({
  subjectiveScores: z.array(AIPerformanceScorePointSchema),
  objectiveScores: z.array(AIPerformanceScorePointSchema),
});

export type TAIPerformanceScores = z.infer<typeof AIPerformanceScoresSchema>;
